import {UnstyledButton, createStyles} from '@mantine/core';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export type FilterTab = 'all' | 'type' | 'project' | 'user';

function HashIcon(): JSX.Element {
  return (
    <svg
      fill="none"
      height="14"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
      width="14"
      aria-hidden="true"
    >
      <line x1="4" x2="20" y1="9" y2="9" />
      <line x1="4" x2="20" y1="15" y2="15" />
      <line x1="10" x2="8" y1="3" y2="21" />
      <line x1="16" x2="14" y1="3" y2="21" />
    </svg>
  );
}

const TAB_CONFIG: Array<{id: FilterTab; label: string; icon: JSX.Element}> = [
  {id: 'type', label: 'Type', icon: <HashIcon />},
  {
    id: 'project',
    label: 'Project',
    icon: <BenchlingIcon icon="folder" style={{fontSize: 14}} aria-hidden="true" />,
  },
  {
    id: 'user',
    label: 'Author',
    icon: <BenchlingIcon icon="person" style={{fontSize: 14}} aria-hidden="true" />,
  },
];

const useStyles = createStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    padding: '8px 16px',
    borderBottom: '1px solid #e9ecef',
  },
}));

interface OmniboxFilterTabsProps {
  activeTab: FilterTab;
  onTabChange: (tab: FilterTab) => void;
}

export default function OmniboxFilterTabs({activeTab, onTabChange}: OmniboxFilterTabsProps): JSX.Element {
  const {classes} = useStyles();
  return (
    <div className={classes.root} role="tablist">
      {TAB_CONFIG.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <UnstyledButton
            key={tab.id}
            role="tab"
            aria-selected={isActive}
            onClick={() => {
              onTabChange(tab.id);
            }}
            sx={(theme) => ({
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              padding: '4px 12px',
              borderRadius: theme.radius.xl,
              fontSize: 13,
              fontWeight: isActive ? 600 : 400,
              color: isActive ? theme.colors.blue[7] : theme.colors.gray[7],
              backgroundColor: isActive ? theme.colors.blue[0] : 'transparent',
              transition: 'all 100ms ease',
              '&:hover': {
                backgroundColor: isActive ? theme.colors.blue[0] : theme.colors.gray[0],
              },
            })}
          >
            {tab.icon}
            {tab.label}
          </UnstyledButton>
        );
      })}
    </div>
  );
}
